import classNames from 'classnames';

import React, {
  forwardRef,
  ForwardRefExoticComponent,
  HTMLAttributes,
  ReactElement,
  RefAttributes,
} from 'react';

import styles from './page.scss';

type Props = RefAttributes<HTMLDivElement> &
  HTMLAttributes<HTMLDivElement> & {
    left?: ReactElement;
    right?: ReactElement;
    dataTestId?: string;
  };

const COMPONENT_ID = 'modulor-page';

export const Page: ForwardRefExoticComponent<Props> = forwardRef<HTMLDivElement, Props>(
  ({ left, right, className, children, ...rest }, ref, dataTestId = COMPONENT_ID) => {
    const classes = classNames(
      styles.page,
      { [styles['no-sidebars']]: !left && !right },
      className,
    );

    return (
      <div
        data-testid={dataTestId}
        data-id={dataTestId}
        data-component-name={COMPONENT_ID}
        ref={ref}
        className={classes}
        {...rest}>
        {left ? (
          <div className={styles.left} data-testid={`${dataTestId}-left`}>
            {left}
          </div>
        ) : null}
        <div className={styles.children} data-testid={`${dataTestId}-center`}>
          {children}
        </div>
        {right ? (
          <div className={styles.right} data-testid={`${dataTestId}-right`}>
            {right}
          </div>
        ) : null}
      </div>
    );
  },
);

Page.displayName = 'Page';
